import React from "reactn"
import { graphql } from "gatsby"
import { Box, Link, Text, WrapItem } from "@chakra-ui/react"
import { GatsbyImage } from "gatsby-plugin-image"
import Obfuscate from "react-obfuscate"

export function StockistCard({ stockist, eager }) {
  const {
    name,
    url,
    address,
    phonenumber,
    image
  } = stockist

  return (
    <WrapItem
      id="stockistSummary"
    >
      <Box>
        <Box width={'284px'} position={'relative'} >
          <Link href={url} alt={name} isExternal>
            <GatsbyImage
              style={{ 
                WebkitMaskImage: "-webkit-radial-gradient(white, black)",
                borderRadius: '50%' 
              }}
              image={image.gatsbyImageData}
              loading={eager ? "eager" : "lazy"}
              alt={name} />
            <Box
              position={'absolute'}
              backgroundColor={'white'}
              bottom={'120px'}
              width={'100%'}
              textAlign='center'
              paddingTop={'10px'}
            >
              <Text variant={"stockist"}>{name}</Text>
            </Box>
          </Link>
        </Box>
        <Box align={'center'} mt={2}>
          <Obfuscate align={'center'} className="obfuscate" tel={phonenumber} />
          <Box align={'center'} dangerouslySetInnerHTML={{ __html: address }} />
        </Box>
      </Box>
    </WrapItem>
  )
}

export const query = graphql`
  fragment StockistCard on DatoCmsStockist  {
    id
    name
    image {
      gatsbyImageData(
        width: 600,
        placeholder: BLURRED,
        forceBlurhash: false,
        imgixParams: { invert: false }
      )
    }
    address
    phonenumber
    slug
    url
  }
`
